/**指标名 -- 字段：文本  -- 用于Bubble提示文本数据源名称*/
export const METRIC_NAME = {
  appannie: 'data.ai',
  appstore: 'AppStore',
  bilibili: 'Bilibili',
  crunchbase: 'Crunchbase',
  databarin: 'Databarin',
  epic: 'Epic',
  fbgaming: 'Fb Gaming',
  googleplay: 'GooglePlay',
  hatchet: 'Hatchet',
  mscience: 'M Science',
  newzoo: 'DataBarin',
  nintendo: 'Nintendo',
  npd: 'NPD',
  playstation: 'Play Station',
  sensortower: 'Sensor Tower',
  steam: 'Steam',
  taptap: 'Taptap',
  twitch: 'Twitch',
  xbox: 'Xbox',
  youtube: 'Youtube',
  gamalytic:'Gamalytic',
  alinea: 'Alinea Analytics',
} as any;